import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    empresas: null,
    agendamentos: null,
    rotinas: null,
    empresa: {
      id: null,
      name: null
    },
    dias: [
      {
        'dia_semana': 'SEGUNDA',
      },
      {
        'dia_semana': 'TERCA',
      },
      {
        'dia_semana': 'QUARTA',
      },
      {
        'dia_semana': 'QUINTA',
      },
      {
        'dia_semana': 'SEXTA',
      },
      {
        'dia_semana': 'SABADO',
      },
      {
        'dia_semana': 'DOMINGO',
      },
      {
        'dia_semana': 'TODOS',
      },
    ],
    infoRotina: null,
    pagination: {
      currentPage: 1,
      perPage: 10
    },
    totalPages: 0,
    filters: {},
    palavras: [],
    monitoramento: []  
  },

  getters: {
    getEmpresas: (state) => state.empresas,
    getAgendamentos: (state) => state.agendamentos,
    getRotinas: (state) => state.rotinas,
    getDias: (state) => state.dias,
    getEmpresa: (state) => state.empresa,
    getTotalPages: (state) => state.totalPages,
    getInfoRotina: (state) => state.infoRotina,
    getPalavras: (state) => state.palavras,
    getMonitoramento: (state) => state.monitoramento
  },

  actions: {
    async getPalavras({ state, commit }){

      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }
      
      try {
        const params = {
          ...state.filters,
          ...pagination
        }

        const response = await api.get('painel/getPalavras?page=' + pagination.page, { params })
      
        commit('setPalavras', response.data.palavras.data)
        commit('setTotalPages', response.data.palavras.last_page)

        return response
      } catch (error) {
        throw new Error(error)
      }
    },

   
    async getMonitoramento({ state, commit }){
      
      try {
        const response = await api.get('painel/getMonitoramento')

        commit('setMonitoramento', response.data)
        return response
      } catch (error) {
        throw new Error(error)
      }
    },


    async setFilters({ state, commit }, { filters }){
      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }
      
      try {
        const params = {
          ...filters,
          ...pagination
        }

        const response = await api.get('painel/setFilters?page=' + pagination.page, { params })

        commit('setAgendamentos', response.data.data)
        commit('setTotalPages', response.data.last_page)
        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async acaoRotina({ commit }, { data }) {

      let response = ''

      if (data.acao_global == 'salvar') {
        response = await api.post('painel/saveRotina', { ...data })
      } else if (data.acao_global == 'editar') {
        response = await api.post('painel/editarRotina', { ...data })
      }

      return response.data
    },

    async deletePalavra({ commit }, { data }) {
      const response = await api.post('painel/deletePalavra', { ...data })

      return response.data
    },

    async acaoDicionario({ commit }, { data }) {
      let response = ''

      if (data.acao_global == 'salvar') {
        response = await api.post('painel/savePalavra', { ...data })
      } else if (data.acao_global == 'editar') {
        response = await api.post('painel/editarPalavra', { ...data })
      }
      return response
    },

    async acaoAgendamento({ commit }, { data }) {
    
      let response = ''

      if (data.acao_global == 'salvar') {
        response = await api.post('painel/saveAgendamento', { ...data })
      } else if (data.acao_global == 'editar') {
        response = await api.post('painel/editarAgendamento', { ...data })
      }

      return response.data
    },

    async deleteRotina({ commit }, { data }) {
      const response = await api.post('painel/deleteRotina', { ...data })

      return response.data
    },

    async deleteAgendamento({ commit }, { data }) {
      const response = await api.post('painel/deleteAgendamento', { ...data })

      return response.data
    },

    async deleteRegistro({ commit }, { data }) {
      console.log(data)
      const response = await api.post('painel/deleteRegistro', { data })

      return response.data
    },

    async getEmpresas({ commit }) {
      try {
        // const params = {
        //   mostrar_em: 1
        // }

        const response = await api.get('painel/getEmpresasPainel')

        commit('setEmpresas', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async selectBases({ commit }, { tp_base }) {
      try {
        // const params = {
        //   mostrar_em: 1
        // }

        const response = await api.post('frota/selectBases', { ...tp_base })

        let bases = response.data.tabelas.filter(object => object.name && object.name.includes('ginfo'))

        console.log(bases)
        commit('setEmpresas', response.data.tabelas)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async getInfoRotina({ commit }, { rotina }) {
      try {

        const params = {
          nr_seq_rotina: rotina
        }

        const response = await api.get('painel/getInfoRotina', { params })

        commit('setInfoRotinas', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async getAgendamentos({ state, commit }, { data }) {
      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }

      try {
        const params = {
          empresa: data,
          ...pagination,
          ...state.filters
        }

        const response = await api.get('painel/getAgendamentos?page=' + pagination.page, { params })

        commit('setAgendamentos', response.data.agendamentos.data)
        commit('setTotalPages', response.data.agendamentos.last_page)
        commit('setEmpresa', response.data.empresa)
      } catch (error) {
        throw new Error(error)
      }
    },

    async registrarExecucao({ commit }, { data }) {
      try {
        const response = await api.post('painel/registrarExecucao', { ...data })
      } catch (error) {
        throw new Error(error)
      }
    },

    async getRotinas({ commit }) {
      try {
        const response = await api.get('painel/getRotinas')

        commit('setRotinas', response.data)
      } catch (error) {
        throw new Error(error)
      }
    }
  },

  mutations: {
    setPalavras(state, palavras) {
      state.palavras = palavras
    },

    setMonitoramento(state, monitoramento) {
      state.monitoramento = monitoramento
    },

    setEmpresas(state, empresas) {
      state.empresas = empresas
    },

    setEmpresa(state, empresa){
      state.empresa.id = empresa.id
      state.empresa.name = empresa.name
    },

    setAgendamentos(state, agendamentos) {
      state.agendamentos = agendamentos
    },

    setRotinas(state, rotinas) {
      state.rotinas = rotinas
    },

    setTotalPages(state, totalPages) {
      state.totalPages = totalPages

    },
    setCurrentPage(state, { page }) {
      state.pagination.currentPage = page
    },
    setInfoRotinas(state, rotina) {
      state.infoRotina = rotina
    },
    setFilters(state, { filters }) {
      state.filters = {
        ...filters
      }
    }
  }
}
